import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { logos } from "../data";

const SHeader = styled.div`
  background: black;
  color: white;
  padding: 10px 0;
  font-size: 25px;
  color: white;

  img {
    height: 50px;
    width: 50px;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a {
    color: white;
    text-decoration: none;

    &:hover {
      opacity: 0.5;
    }
  }
  gap: 20px;
`;

const HeaderLink = styled(Link)`
  transform: ${(props) => (props.isactive ? "scale(1.2)" : "")};
  transition: all 500ms;
  margin: 7px;
`;

export const Header = () => {
  const loc = useLocation();

  return (
    <SHeader>
      <div>
        <HeaderLink isactive={loc.pathname === "/"} to="/">
          🧮
        </HeaderLink>
        <HeaderLink isactive={loc.pathname === "/cbd"} to="/cbd">
          <img alt="header-btn" src={logos.cbd} />
        </HeaderLink>
        <HeaderLink isactive={loc.pathname === "/gla"} to="/gla">
          <img alt="header-btn" src={logos.gla} />
        </HeaderLink>
        <HeaderLink isactive={loc.pathname === "/pen"} to="/pen">
          <img alt="header-btn" src={logos.pen} />
        </HeaderLink>
        <HeaderLink isactive={loc.pathname === "/hur"} to="/hur">
          <img alt="header-btn" src={logos.hur} />
        </HeaderLink>
        <HeaderLink isactive={loc.pathname === "/brackets"} to="/brackets">
          🔃
        </HeaderLink>
        {/* <HeaderLink isactive={loc.pathname === "/setrosters"} to="/setrosters">
          🤼
        </HeaderLink> */}
      </div>
    </SHeader>
  );
};
